export default "__VITE_ASSET__8b70e3fa__"